export { PointsInfoBoxBlok } from "./PointsInfoBoxBlok";
